import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 18a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M4 6a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M16 18a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-2"}],["path",{"d":"M6 8l0 8","key":"svg-3"}],["path",{"d":"M11 6h5a2 2 0 0 1 2 2v8","key":"svg-4"}],["path",{"d":"M14 9l-3 -3l3 -3","key":"svg-5"}]]

const IconGitPullRequest = createReactComponent('outline', 'git-pull-request', 'GitPullRequest', __iconNode);

export default IconGitPullRequest;